import * as React from "react";
import Grid from "@mui/material/Grid";
import ChatInfoLine from "./InfoLine";
import {ChatDestinationEntry, ChatDestinations, ContactOptions} from "./Chat";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmailIcon from "@mui/icons-material/Email";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import Typography from "@mui/material/Typography";

interface ChatDestinationSelectProps {
    selectedDestination: ChatDestinationEntry;
    handleDestinationBack: () => void;
    contactOption: string;
    sendMessage: (entry: ChatDestinationEntry) => void;
}

export default function ChatDestinationDetails(props: ChatDestinationSelectProps) {

    return <>
        <Grid container direction={"column"}>

            <Grid item>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item mb={2} mt={1}>
                        <ChatInfoLine icon={props.selectedDestination.icon}>
                            {props.selectedDestination.name}
                        </ChatInfoLine>
                    </Grid>
                    <Grid item>
                        {(props.contactOption == ContactOptions.Calendar && props.selectedDestination.destination === ChatDestinations.Verkauf) ? (
                            <a href={props.selectedDestination.calendarLink} target={"_blank"}>
                                <span className={'dest-link'}>
                                <ChatInfoLine icon={<CalendarTodayIcon/>} text={"Termin vereinbaren"}/>
                                    </span>
                            </a>
                        ) : (
                            <>
                                {props.contactOption == ContactOptions.Calendar && props.selectedDestination.destination !== ChatDestinations.Verkauf &&
                                    <Grid item mb={2}>
                                        <Typography>
                                            {"Eine digitale Terminvereinbarung steht für diesen Bereich nicht zur Verfügung. Bitte wenden Sie sich telefonisch oder per E-Mail an:"}
                                        </Typography>
                                    </Grid>
                                }

                                <Grid item className={"destination-details"}>
                                    <ChatInfoLine icon={<EmailIcon/>}>
                                        <a href={"mailto:" + props.selectedDestination.email}><span
                                            className={"dest-link"}>{props.selectedDestination.email}</span></a>
                                    </ChatInfoLine>
                                </Grid>

                                <Grid item className={"destination-details"}>
                                    <ChatInfoLine icon={<PhoneEnabledIcon/>}>
                                        <a href={"tel:" + props.selectedDestination.phone.replaceAll(' ', '')}><span
                                            className={"dest-link"}>{props.selectedDestination.phone}</span></a>
                                    </ChatInfoLine>
                                </Grid>

                                <Grid item className={"destination-details destination-details-message"}>
                                    <button className="btn btn-active white"
                                            onClick={() => props.sendMessage(props.selectedDestination)}>Nachricht schreiben
                                    </button>
                                </Grid>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Grid>

            <Grid item mt={4} onClick={() => props.handleDestinationBack()}>
                <ChatInfoLine icon={<ArrowBackIcon/>} text={"Zurück"}/>
            </Grid>
        </Grid>
    </>
}